import React, { createContext, useState } from 'react';

interface AuthContextProps {
  token: string | null;
  username: string | null;
  setToken: (token: string | null) => void;
  setUsername: (username: string | null) => void;
}

export const AuthContext = createContext<AuthContextProps>({
  token: null,
  username: null,
  setToken: () => {},
  setUsername: () => {},
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [token, setToken] = useState<string | null>(null);
  const [username, setUsername] = useState<string | null>(null);

  return (
    <AuthContext.Provider value={{ token, username, setToken, setUsername }}>
      {children}
    </AuthContext.Provider>
  );
};
